/**
 * MAP-990: shared helpers for the "core style" expand/collapse toggle used in
 * the node/link/smap style sections (see StyleGroupExpansionService).
 *
 * Kept as plain data/functions (not per-field template logic) so that new
 * dependents can be added to any core style later (e.g. MAP-852's hue slider
 * under "color") without touching this file.
 */

/**
 * A tooltip label override table: some core styles are named differently in
 * their expand/collapse tooltip than their display label. Only "label font
 * size" needs this today (AC9: tooltip says "label", not "label font size"),
 * but the table keeps future overrides a one-line addition.
 */
const TOOLTIP_LABEL_OVERRIDES: Record<string, string> = {
  'label font size': 'label',
};

/**
 * "Show dependent <core-style-name> styles" / "Hide dependent <core-style-name>
 * styles" (AC9), e.g. styleGroupToggleTooltip('color', false) === 'Show
 * dependent color styles'.
 */
export function styleGroupToggleTooltip(coreStyleName: string, expanded: boolean): string {
  const label = TOOLTIP_LABEL_OVERRIDES[coreStyleName] ?? coreStyleName;
  return expanded ? `Hide dependent ${label} styles` : `Show dependent ${label} styles`;
}

/**
 * Storage id for a core style, derived from its display name:
 * 'color' -> 'color', 'label font size' -> 'labelFontSize',
 * 'background image' -> 'backgroundImage', 'ambient sound' -> 'ambientSound'.
 * Callers prefix it with their section ('node.', 'link.', 'smap.').
 */
export function coreStyleGroupId(coreStyleName: string): string {
  return coreStyleName.replace(/\s+(.)/g, (_, char: string) => char.toUpperCase());
}
